module.exports = __webpack_public_path__ + "static/media/takao-oba.a391d1e8.jpg";